// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg width=%2718%27 height=%2718%27 viewBox=%270 0 24 24%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M13.7902 7.12003C14.5602 9.88003 16.7202 12.04 19.4902 12.82M15.0902 5.82003L6.00016 14.91C5.65016 15.26 5.31016 15.94 5.24016 16.43L4.74016 19.9C4.56016 21.16 5.44016 22.04 6.70016 21.86L10.1702 21.36C10.6502 21.29 11.3402 20.94 11.6902 20.6L20.7902 11.5C22.3602 9.93003 23.1002 8.11003 20.7902 5.80003C18.4802 3.49003 16.6602 4.23003 15.0902 5.80003V5.82003Z%27 stroke=%27black%27 stroke-width=%271.5%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3Cpath d=%27M6.18 1.79986C6.25 1.62986 6.5 1.62986 6.57 1.79986L7.72 4.52986C7.74 4.57986 7.78 4.61986 7.83 4.63986L10.56 5.78986C10.73 5.85986 10.73 6.10986 10.56 6.17986L7.83 7.32986C7.78 7.34986 7.74 7.38986 7.72 7.43986L6.57 10.1699C6.5 10.3399 6.25 10.3399 6.18 10.1699L5.03 7.43986C5.01 7.38986 4.97 7.34986 4.92 7.32986L2.19 6.17986C2.02 6.10986 2.02 5.85986 2.19 5.78986L4.92 4.63986C4.97 4.61986 5.01 4.57986 5.03 4.52986L6.18 1.79986Z%27 stroke=%27black%27 stroke-width=%271.5%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes SvuYl{0%{background-position:0% 50%}50%{background-position:100% 50%}100%{background-position:0% 50%}}.cPE4t{display:inline-flex;justify-content:center;align-items:center;position:relative;margin-left:auto}.cPE4t button{display:inline-flex !important;justify-content:center !important;align-items:center !important;gap:4px !important}.cPE4t button svg{width:18px !important;height:18px !important}.cPE4t button>span{display:inline-flex;align-items:center;justify-content:center}.N79Pw{display:inline-flex;align-items:center;position:relative;transition:color .15s ease}.N79Pw::after{content:attr(data-text);position:absolute;top:0;left:0;width:100%;height:100%;background:linear-gradient(135deg, #2CF1FF 0%, #9578FF 50%, #FF36E7 100%);background-size:200% 100%;background-clip:text;-webkit-background-clip:text;-webkit-text-fill-color:transparent;color:transparent;opacity:0;transition:opacity .15s ease .1s;pointer-events:none;white-space:nowrap;z-index:1}.AZuwK{display:flex;align-items:center;justify-content:center;position:relative;width:18px;height:18px;flex-shrink:0;padding:0}.AZuwK::after{content:"";position:absolute;top:0;left:0;width:18px;height:18px;background:linear-gradient(135deg, #2CF1FF 0%, #9578FF 50%, #FF36E7 100%);background-size:200% 100%;opacity:0;transition:opacity .15s ease .1s;z-index:1;pointer-events:none;-webkit-mask-image:url(${___CSS_LOADER_URL_REPLACEMENT_0___});mask-image:url(${___CSS_LOADER_URL_REPLACEMENT_0___});-webkit-mask-size:contain;mask-size:contain;-webkit-mask-repeat:no-repeat;mask-repeat:no-repeat;-webkit-mask-position:center;mask-position:center}.AZuwK svg{position:relative;z-index:0;width:18px;height:18px;display:block;transition:opacity .15s ease}.cPE4t:hover:not(:has(button[disabled])) .N79Pw{color:transparent !important;transition:color .15s ease .1s}.cPE4t:hover:not(:has(button[disabled])) .N79Pw::after{opacity:1;animation:SvuYl 3s ease-in-out infinite;transition:opacity .1s ease}.cPE4t:hover:not(:has(button[disabled])) .AZuwK::after{opacity:1;animation:SvuYl 3s ease-in-out infinite;transition:opacity .1s ease}.cPE4t:hover:not(:has(button[disabled])) .AZuwK svg{opacity:0;transition:opacity .15s ease .1s}.K2UQs{display:flex;align-items:center;gap:8px;flex:1}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blue45": `#fcfcff`,
	"blue48": `#f5f7fd`,
	"blue50": `#f3f5ff`,
	"blue300": `#dae0ff`,
	"blue500": `#c0caff`,
	"blue600": `#a1aef5`,
	"blue700": `#8296ff`,
	"blue800": `#6176e7`,
	"dark50": `#fcfcfd`,
	"dark70": `#f4f4f7`,
	"dark100": `#eaeaef`,
	"dark120": `#e4e4ec`,
	"dark200": `#d4d4e0`,
	"dark300": `#bfbfd0`,
	"dark400": `#a9a9c1`,
	"dark500": `#9393b1`,
	"dark600": `#7e7ea1`,
	"dark700": `#696992`,
	"dark800": `#535382`,
	"dark900": `#282863`,
	"green45": `#eff6fa`,
	"green50": `#f3fcfa`,
	"green300": `#b6ebdf`,
	"green500": `#86ddca`,
	"green700": `#56d0b5`,
	"green800": `#36b89b`,
	"green900": `#089475`,
	"orange50": `#fdf2dc`,
	"orange300": `#fadea8`,
	"orange500": `#f9d797`,
	"orange700": `#f7ca75`,
	"orange800": `#f5bd52`,
	"orange900": `#dd9306`,
	"purple50": `#e1d9fe`,
	"purple300": `#c3b3fc`,
	"purple500": `#a58efb`,
	"purple700": `#8768f9`,
	"purple800": `#6942f8`,
	"purple900": `#4520cc`,
	"red200": `#fdf0f0`,
	"red300": `#fee3e3`,
	"red500": `#f9d5d5`,
	"red700": `#f3aaaa`,
	"red900": `#eb7272`,
	"red950": `#e86161`,
	"red970": `#dd4c4c`,
	"white": `#fff`,
	"defaultTextStandard": `#282863`,
	"defaultTextSecondary": `#696992`,
	"defaultButtonPrimary": `#6942f8`,
	"buttonPrimary": `var(--button-primary, #6942f8)`,
	"buttonPrimaryDark": `var(--button-primary-dark, #4520cc)`,
	"buttonDisabled": `var(--button-disabled, #bfbfd0)`,
	"buttonDisabledDark": `var(--button-disabled-dark, #a9a9c1)`,
	"defaultButtonDisabled": `#bfbfd0`,
	"defaultStepperCompleted": `#089475`,
	"defaultStepperIncomplete": `#d4d4e0`,
	"defaultButtonSecondary": `#fcfcfd`,
	"defaultBgStandard": `#f3f5ff`,
	"defaultBgLight": `#fff`,
	"helpMeWriteButtonWrapper": `cPE4t`,
	"textWrapper": `N79Pw`,
	"iconWrapper": `AZuwK`,
	"gentleGradient": `SvuYl`,
	"toolbarActionsRow": `K2UQs`
};
export default ___CSS_LOADER_EXPORT___;
